<script>

	const Content = {
		functional: true,
		props: {
			centered: Boolean
		},
		render (h, ctx) {
			return (
				<div class={['content', { centered: ctx.props.centered }]}>
					{ctx.children}
				</div>
			)
		}
	}

	Content.Headline = {
		functional: true,
		props: {
			pre: [String, Object],
			primary: [String, Object]
		},
		render (h, ctx) {
			const { pre, primary } = ctx.props
			return (
				<div class="headline">
					{pre && (
						<div class="pre">{pre}</div>
					)}
					<h2 class="primary">{primary}</h2>
				</div>
			)
		}
	}

	Content.SubHeadline = {
		functional: true,
		render (h, ctx) {
			return (
				<h3 class="sub-headline">{ctx.children}</h3>
			)
		}
	}

	export default Content

</script>

<style lang="scss" scoped>

	@import "media.scss";
	@import "responsive-font.scss";

	.content {
		&.centered {
			text-align:center;
		}
		/deep/ {
			.headline {
				margin-bottom:3rem;
				.pre {
					@include responsive-font(20);
					line-height:1.2; font-weight:400; color:#FDB913; text-transform:uppercase; margin-bottom:.8rem; font-family:"oswald";
				}
				.primary{
					@include responsive-font(40);
					line-height:1.25; font-weight:400; color:#3D3D3D; text-transform:uppercase;
					@include media(small, large) {
						@include responsive-font(35);
					}
				}
			}
			.sub-headline {
				@include responsive-font(20);
				color:#3D3D3D; font-weight:600; line-height:1.25; font-family:'proxima-nova'; margin-bottom:.8rem;
				& + p {
					margin-top:0;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/RemoteResources/Content.vue